export type CityShareState = "before_sehri" | "before_iftar" | "after_iftar";

export function buildWhatsAppUrl(message: string) {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}

export function buildCityShareText({
  city,
  sehri,
  iftar,
  dateLabel,
  url,
  state,
  nextSehri,
}: {
  city: string;
  sehri: string;
  iftar: string;
  dateLabel: string;
  url: string;
  state: CityShareState;
  nextSehri?: string;
}) {
  const headline =
    state === "after_iftar"
      ? nextSehri
        ? `Kal ${city} mein Sehri ${nextSehri} hai.`
        : `Aaj ${city} mein Iftar ${iftar} ho chuki hai.`
      : state === "before_iftar"
        ? `Aaj ${city} mein Iftar ${iftar} hai.`
        : `Aaj ${city} mein Sehri ${sehri} aur Iftar ${iftar} hai.`;

  return `${headline}\n\n${dateLabel}\n\nRozana updated timings dekhein:\n${url}`;
}

export function buildCalendarShareText({
  city,
  url,
}: {
  city: string;
  url: string;
}) {
  return `Ramzan 2026 Calendar - ${city}\n\nPoora 30-day Sehri aur Iftar schedule yahan dekhein:\n${url}`;
}
